import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import * as Hammer from 'hammerjs';

import { interval, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import { Company, ConfigService } from '../../../services/config.service';
import { TourService } from '../../../services/tour.service';
import { GlobalVariables } from '../../../data/global-variables';
import { BookService } from '../../../services/book.service';
import { ReportService } from '../../../services/report.service';
import { AlertService } from '../../../services/alert.service';
import { ImagesCacheService } from '../../../services/images-cache.service';
import { StudiesService } from '../../../services/studies.service';
import { BookImage, BookImageType, BookPageType } from '../../../data/book';
import { environment } from '../../../../environments/environment';
import { FloatingVisorComponent } from '../../../floating-visor/floating-visor.component';
import { AnimationsComponent } from '../../../utils/animations/animations.component';
import { ShareStudyComponent } from '../../../utils/share-study/share-study.component';
import { Tab } from './bottom-nav/tab.type';
import { InfoStudyComponent } from 'src/app/utils/info-study/info-study.component';
import { VerticalHeaderComponent } from 'src/app/header/vertical-header/vertical-header.component';
import { SafeHtml } from '@angular/platform-browser';
import { Study } from 'src/app/data/study';

@Component({
  selector: 'app-book-pdf-flipbook-vertical',
  templateUrl: './book-pdf-flipbook-vertical.component.html',
  styleUrls: ['./book-pdf-flipbook-vertical.component.css']
})
export class BookPdfFlipbookVerticalComponent implements OnInit, AfterViewInit {
  @Input() token!: string;
  downloading: number | null = null;
  showSpinner = false;
  shownVisorTip = false;
  showWindowingTool: boolean = true
  ignoreOpenPreview: boolean = false
  previewSize: number = 600
  previewLeft: number = 10
  bodyScale = 1;
  flipbookLoaded: boolean = false
  caducityTime: Date | null = null;
  flipbookLoading: boolean = false

  visorOpen: boolean = false;
  swiperAutoplayConfig: string | boolean = false;
  currentSlide: number = 1;
  activeTab: Tab = 'book';

  menuOpened = false;

  bookReports: {
      data: SafeHtml | string;
      auxData: SafeHtml[] | string[];
      type: 'pdf' | 'png' | 'html';
      studyUID: string;
    }[] = [];

  bookStudies: Study[] = [];

  locator: string = ' - ';

  @ViewChildren(FloatingVisorComponent) viewers!: QueryList<FloatingVisorComponent>;
  @ViewChild(AnimationsComponent) animations!: AnimationsComponent;

  @ViewChild(ShareStudyComponent) shareStudyModal!: ShareStudyComponent;
  @ViewChild(InfoStudyComponent) infoStudyModal!: InfoStudyComponent;

  @ViewChild(VerticalHeaderComponent) verticalHeaderComponent!: VerticalHeaderComponent;

  @ViewChild('bookSwiper') bookSwiper!: ElementRef;

  //subscription: Subscription; // Observer para poder cambiar la visibilidad de componenetes desde el tour

  BookPageType = BookPageType;
  BookImageType = BookImageType

  company!: Company;
  public Company = Company;
  window = window;

  constructor(
    public tourService: TourService,
    public globalVariables: GlobalVariables,
    public bookService: BookService,
    public reportService: ReportService,
    private alertService: AlertService,
    public imagesService: ImagesCacheService,
    private configService: ConfigService,
    private changeDetectorRef: ChangeDetectorRef,
    private studiesService: StudiesService,
    private cookieService: CookieService,
  ) {


    /*this.subscription = this.tourService.observable$.subscribe((n) => {

      switch (n) {
        case 70:
          if (this.bookService.currentBook != null) {
            if (this.bookService.currentBook.pages[1].bookImages[0].dicomFile != null) {
              this.openPreview(this.bookService.currentBook.pages[1].bookImages[0]);
   
            }
          }
          break
      }
     
 
    })*/

  }


  ngAfterViewInit(): void {

    interval(2000)
      .pipe(
        take(3),
        filter(() => this.reportService.reports.length > 0),
        take(1))
      .subscribe(() => {
        this.bookReports = this.reportService.reports;
      });
    /* TOUR DISABLED - se activará más adelante
    this.tourService.deleteAllSteps(20);

    console.log("TourMode activado¿? --> ", this.tourService.tourMode);
    if (this.tourService.tourMode == "always") {
      setTimeout(() => {
        this.tourService.initMobileTour();
        this.startVerticalMobileTour();
      }, 500);
    } else if (this.tourService.tourMode == "cookies") {
      if (!this.checkCookieTour()) {
        setTimeout(() => {
          this.tourService.initMobileTour();
          this.startVerticalMobileTour();
        }, 500);

      }
    } else if (this.tourService.tourMode == "basic") {
      if (!this.checkCookieTour()) {
        this.tourService.initMobileTour();
        this.headerComponent.isCollapsed = false; // Llamar al método para abrir el menú
        setTimeout(() => {
          this.headerComponent.startBasicTour();
        }, 500);

      }
    }
    TOUR DISABLED */
  }


  checkCookieTour(): boolean {

    if (this.cookieService.get('cookieTourVerticalMobile')) {
      console.log("Cookie movil vertical encontrada");
      return true;
    } else {
      console.log("Cookie movil vertical no encontrada, se procede a su creación");
      this.cookieService.set('cookieTourVerticalMobile', 'cookieTourVerticalMobile')
      return false;
    }
  }

  ngOnInit(): void {
    // Cuando el visor esté abierto, prevenir el botón atrás y cerrar el visor
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', event => {
      if (this.viewers.some(v => v.isOpen)) {
        this.viewers.forEach(v => v.hide());
        history.pushState(null, document.title, location.href);
      } else {
        history.back();
      }
    });

    if (this.bookService.currentBook != null) {
      setTimeout(() => {
        this.resizeBookVertical();
      }, 300);
    }

    this.refreshCompany();
  }

  refreshCompany() {
    this.company = this.configService.company;
    if (this.company == Company.NOT_DEFINED) {
      setTimeout(() => {
        this.refreshCompany();
      }, 200);
    }
  }

  public loadBook() {
    this.showSpinner = true;
    this.changeDetectorRef.detectChanges()
    this.bookService.loadBookByToken(this.token).then(() => {
      this.bookService.startLoadingBook();
      this.flipbookLoading = true;

      // Esperar a que los informes estén cargados antes de inicializar Swiper.
      this.bookService.reportsLoaded$.pipe(take(1)).subscribe(() => {
        this.showSpinner = false;
        this.flipbookLoading = false;
        this.flipbookLoaded = true;
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
          this.initSwiper();
          this.resizeBookVertical();
        }, 50);
      });
    })

    this.getBookStudies(this.token).then(sts => {
      this.bookStudies = sts;
    }).catch(() => {});

    this.bookService.getLocatorByToken(this.token).then(locator => {
      this.locator = locator;
    }).catch(error => {
      console.error(error);
    })

    this.bookService.checkExpiringTime(this.token).subscribe(time => {
      this.configService.getConfig().then(c => {
        this.caducityTime = new Date(time);
      })
    })
  }

  getBookStudies(token: string): Promise<Study[]> {
  
    return new Promise((resolve, reject) => {
      if(token != null && token != ""){
        this.studiesService.getStudiesByToken(token).then(studies => {
          resolve(studies);
        })
      }else{
        reject('No token provided');
      }
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {

    this.animations.cancelAnimations();
    if (this.flipbookLoaded) {
      this.flipbookLoaded = false;
      // if (this.isPageSmall) {
      //   this.animations.showFingerAnimation('vertical');
      // }
    }

    this.resizeBookVertical();
  }

  public resizeBookVertical() {
    const pages = document.getElementsByClassName('swiper-slide');
    if (pages != null && pages.length != 0) {
      for (let i = 0; i < pages.length; i++) {
        const p = pages.item(i) as HTMLDivElement;
        p.style.height = (window.innerWidth * 1.41428) + 'px';
      }
    }
  }

  public set setFipbookLoaded(loaded: boolean) {
    this.flipbookLoaded = loaded
  }

  public get isFlipbookLoaded() {
    return this.flipbookLoaded
  }

  get isPageSmall() {
    return this.globalVariables.isPageSmall;
  }

  public onSlideChange(event: any): void {
    const swiper = event?.detail?.[0];
    if (swiper) {
      this.currentSlide = (swiper.activeIndex ?? 0) + 1;
    }
  }

  /*public slidePrev(): void {
    const swiperEl = this.bookSwiper?.nativeElement?.swiper;
    if (swiperEl?.swiper) { swiperEl.swiper.slidePrev(); }
  }

  public slideNext(): void {
    const swiperEl = this.bookSwiper?.nativeElement?.swiper;
    if (swiperEl?.swiper) { swiperEl.swiper.slideNext(); }
  }*/

  
  slidePrev(): void {

    console.log('Intentando retroceder a la página anterior. Página actual:', this.currentSlide);
    const swiper =
      this.bookSwiper?.nativeElement?.swiper;

    if (!swiper || this.currentSlide <= 1) {
      return;
    }

    swiper.slidePrev();
  }

  slideNext(): void {
    console.log('Intentando avanzar a la siguiente página. Página actual:', this.currentSlide);

    const swiper =
      this.bookSwiper?.nativeElement?.swiper;

    if (
      !swiper ||
      this.currentSlide >= this.bookService.allPages.length
    ) {
      console.log('return de siguiente');
      console.log('SWIPER', swiper);
      return;
    }

    swiper.slideNext();
  }

  public setTab(tab: Tab): void {
    this.activeTab = tab;
    this.currentSlide = 1;
    if (tab === 'book' && this.flipbookLoaded) {
      setTimeout(() => {
        this.initSwiper();
        this.resizeBookVertical();
      }, 50);
    }
  }

  toggleMenu(): void {
    this.menuOpened = !this.menuOpened;
  }

  closeMenu(): void {
    this.menuOpened = false;
  }

  openViewer(): void {
    console.log('Abrir visor');
  }

  openDownloadReport(): void {
    console.log('Descargar informe');
  }

  /** Navigate Swiper to a specific slide index (used by guided tour buttons) */
  public navigateToSlide(index: number): void {
    const swiperEl = this.bookSwiper?.nativeElement?.swiper;
    if (swiperEl?.swiper) {
      swiperEl.swiper.slideTo(index, 0);
    }
  }

  private initSwiper(): void {
    const swiperEl = this.bookSwiper?.nativeElement;
    if (!swiperEl) return;

    const autoplayDelay: number = this.configService.config?.swiper_autoplay_delay ?? 0;

    Object.assign(swiperEl, {
      effect: 'creative',
      grabCursor: true,
      loop: false,
      touchStartPreventDefault: false,
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, 0, -400],
        },
        next: {
          translate: ['100%', 0, 0],
        },
      },
      autoplay: autoplayDelay > 0 ? { delay: autoplayDelay, disableOnInteraction: true } : false,
    });
    swiperEl.initialize();
  }

  download() {
    // if (!environment.demo) {
    //   if (this.downloading == null) {
    //     this.downloading = 0;
    //     this.bookService.downloadStudy(this.bookService.currentBookWithReports.studyUIDs).subscribe(event => {
    //       if (event.type == HttpEventType.DownloadProgress) {
    //         const percentage = (event.loaded / event.total) * 100
    //         console.log('percentage: ', percentage);
    //         this.downloading = Math.round(percentage)
    //       }

    //       if (event.type == HttpEventType.Response) {
    //         saveAs(event.body, "dicomdir.zip");
    //         this.downloading = null;
    //       }
    //     })
    //   }
    // }
  }

  showMenu() {
    this.visorOpen = false;
  }

  sendMail(mail: string) {

    if (!environment.demo) {
      if(this.configService._systemConfig?.prpSlave){
        this.bookService.sendBookMailByPRP(mail, this.token).subscribe(res => {
          if(res){
            this.alertService.alert('Correo enviado');
          }else{
            this.alertService.alert('Ha ocurrido un error al enviar el correo');
          }
          
        });
      }else{
        this.bookService.sendNotifToMail(mail, this.token).subscribe(res => {
          this.alertService.alert('Correo enviado');
          // alert('Correo enviado')
        });
      }
      
    }
  }

  // checkAskForSerieImg() {
  //   const viewerToUse = this.viewers.first;
  //   let route = this.imagesService.getRouteByImageId(viewerToUse.currentImage);
  //   this.configService.surrounding_images.then(surrounding => {
  //     if (viewerToUse.loadedImages - (viewerToUse.currentIndex + 1) < surrounding) {
  //       const target = this.bookService.getMoreImages('after', route);
  //       if (!this.imagesService.isLoaded(target)) {
  //         // TODO No estoy seguro de si aquí vale usar el join
  //         viewerToUse.loadOneMoreImage(this.bookService.currentBookWithReports.studyUIDs.join(','), target)
  //       }
  //     }
  //     if (viewerToUse.currentIndex < surrounding) {
  //       const target = this.bookService.getMoreImages('before', route);
  //       if (!this.imagesService.isLoaded(target)) {
  //         // TODO No estoy seguro de si aquí vale usar el join
  //         viewerToUse.loadOneMoreImage(this.bookService.currentBookWithReports.studyUIDs.join(','), target)
  //       }
  //     }
  //   })
  // }

  /*hammerIt(elm: HTMLElement) {
    const hammertime = new Hammer(elm, {});
    hammertime.get('pinch').set({
      enable: true
    });
    var posX = 0,
      posY = 0,
      last_scale = 1,
      last_posX = 0,
      last_posY = 0,
      max_pos_x = 0,
      max_pos_y = 0,
      transform = "",
      el = elm;

    hammertime.on('doubletap pan pinch panend pinchend', (ev: HammerInput) => {
      if (this.isPageSmall) {
        const viewerToUse = this.viewers.first;
        if (!viewerToUse.isOpen) {
          if (ev.type == "doubletap") {
            transform =
              "translate3d(0, 0, 0) " +
              "scale3d(2, 2, 1) ";
            this.bodyScale = 2;
            last_scale = 2;
            try {
              if (window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString() != "matrix(1, 0, 0, 1, 0, 0)") {
                transform =
                  "translate3d(0, 0, 0) " +
                  "scale3d(1, 1, 1) ";
                this.bodyScale = 1;
                last_scale = 1;
              }
            } catch (err) { }
            el.style.webkitTransform = transform;
            transform = "";
          }

          //pan    
          if (this.bodyScale != 1) {
            posX = last_posX + ev.deltaX;
            posY = last_posY + ev.deltaY;
            max_pos_x = Math.ceil((this.bodyScale - 1) * el.clientWidth / 2);
            max_pos_y = Math.ceil((this.bodyScale - 1) * el.clientHeight / 2);
            if (posX > max_pos_x) {
              posX = max_pos_x;
            }
            if (posX < -max_pos_x) {
              posX = -max_pos_x;
            }
            if (posY > max_pos_y) {
              posY = max_pos_y;
            }
            if (posY < -max_pos_y) {
              posY = -max_pos_y;
            }
          }

          //pinch
          if (ev.type == "pinch") {
            this.bodyScale = Math.max(.999, Math.min(last_scale * (ev.scale), 4));
          }
          if (ev.type == "pinchend") { last_scale = this.bodyScale; }

          //panend
          if (ev.type == "panend") {
            last_posX = posX < max_pos_x ? posX : max_pos_x;
            last_posY = posY < max_pos_y ? posY : max_pos_y;
          }

          if (this.bodyScale != 1) {
            transform =
              "translate3d(" + posX + "px," + posY + "px, 0) " +
              "scale3d(" + this.bodyScale + ", " + this.bodyScale + ", 1)";
          }

          if (transform) {
            el.style.webkitTransform = transform;
          }
        }
      }
    });
  }*/

  /** Swipe navigation is now handled natively by Swiper.
   * HammerJS is retained only for pinch/zoom within each slide via hammerIt().
   */
  /*public refreshGestures(): void {
    this.hammerIt(document.body);
  }*/

  openPreview(image: BookImage, event?: any) {
    this.visorOpen = true;
    this.showWindowingTool = true
    if (this.ignoreOpenPreview) return

    document.body.style.transform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";
    document.body.style.webkitTransform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";

    // console.log('opening img: ', image);

    const viewerToUse = this.viewers.first;
    if (this.bookService.currentBook!.advancedVisor) {
      viewerToUse.activateAdvancedMode();
    }

    if (!this.isPageSmall) {
      // console.log(event);

      this.previewLeft = event.clientX - (this.previewSize / 2);
    }
    this.showSpinner = true;

    switch (image.type) {
      case BookImageType.SERIES:
        const serieImagesSeries = this.bookService.currentBook!.studyInfo.find(s =>
          s.files.some(f => f == image.dicomFile) ||
          s.files.some(f => f.split('\\')[f.split('\\').length - 1] == image.dicomFile) ||
          s.files.some(f => f.split('/')[f.split('/').length - 1] == image.dicomFile)
        );
        // const serieImagesSeries = this.bookService.currentBookWithReports.studyInfo.find(s => s.serie == image.seriesUID);
        console.log('serieImages', serieImagesSeries);

        const instancesSeries = serieImagesSeries!.files.map(img => {
          let filename = img.split('\\')[img.split('\\').length - 1];
          filename = filename.split('/')[filename.split('/').length - 1];
          console.log('filename', filename);
          const instanceUID = filename.substring(0, filename.length - 4)
          return instanceUID;
        });

        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadSerie(this.bookService.currentBook!.studyUIDs.join(','), instancesSeries).then(() => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });

        break;
      case BookImageType.CINE:
        const serieImagesCine = this.bookService.currentBook!.studyInfo.find(s =>
          s.files.some(f => f == image.dicomFile) ||
          s.files.some(f => f.split('\\')[f.split('\\').length - 1] == image.dicomFile) ||
          s.files.some(f => f.split('/')[f.split('/').length - 1] == image.dicomFile)
        );
        // const serieImagesCine = this.bookService.currentBookWithReports.studyInfo.find(s => s.serie == image.seriesUID);
        console.log('serieImages', serieImagesCine);

        const instancesCine = serieImagesCine!.files.map(img => {
          let filename = img.split('\\')[img.split('\\').length - 1];
          filename = filename.split('/')[filename.split('/').length - 1];
          console.log('filename', filename);
          const instanceUID = filename.substring(0, filename.length - 4)
          return instanceUID;
        });

        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadSerie(this.bookService.currentBook!.studyUIDs.join(','), instancesCine).then(() => {
          viewerToUse.playClip();
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });

        break;
      case BookImageType.GRID:
        viewerToUse.setGrid(image.gridSettings!.grid.rows, image.gridSettings!.grid.columns);
        // TODO No estoy seguro de si aquí vale usar el join
        viewerToUse.loadGridImages(image.gridSettings!.grid, this.bookService.currentBook!.studyUIDs.join(','), image.gridSettings!.dicomFiles).then(res => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });
        break;
      case BookImageType.UNIQUE:
      default:
        let filename = image.dicomFile!.split('\\')[image.dicomFile!.split('\\').length - 1];
        filename = filename.split('/')[filename.split('/').length - 1];
        console.log('filename', filename);
        const instanceUID = filename.substring(0, filename.length - 4)
        viewerToUse.loadImage(this.bookService.currentBook!.studyUIDs.join(','), instanceUID).then(() => {
          this.showSpinner = false;
        }).catch(error => {
          this.showSpinner = false;
          alert('Ha ocurrido un error tratando de cargar la imagen. Por favor, vuelva a intentarlo más tarde');
        });
        break;
    }

    const swiperEl = this.bookSwiper?.nativeElement?.swiper;
    if (swiperEl?.swiper) {
      swiperEl.swiper.slideTo(0, 0);
    }
  }

  openShareModal() {
    this.shareStudyModal.open(this.locator);
  }

  openInfoModal() {
    this.infoStudyModal.openModal(this.locator, this.bookStudies, this.caducityTime);
  }

  downloadReport() {
    this.reportService.downloadReports(this.bookService.currentBook!.studyUIDs[0]);
  }

  getReports(){

  }

  startVerticalMobileTour() {
    /* TOUR DISABLED - se activará más adelante
    console.log("Añadiendo pasos del tour movil vertical");

    this.navigateToSlide(0);

    this.tourService.guideTour.addSteps([

      {
        id: "btn-1",
        attachTo: {
          element: "#book-container > div",
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.tourService.guideTour.cancel();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.navigateToSlide(1);
              setTimeout(() => {
                this.tourService.guideTour.next();
              }, 100)
            }
          }
        ],
        text: "<p>Esta es la portada de tu Book digital</p>" +
          "<p>Podrás deslizar para pasar a la siguiente página</p>",
      },
      {
        id: "btn-2",
        attachTo: {
          element: "#book-container > div",
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.navigateToSlide(0);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.navigateToSlide(0);
              setTimeout(() => {
                this.tourService.guideTour.back();
              }, 100)
            }

          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.navigateToSlide(2);
              setTimeout(() => {
                this.tourService.guideTour.next();
              }, 100)
            }
          }
        ],
        text: "<p>En la primera página tenemos el informe resultante del estudio<p>",

      },
      {
        id: "btn-3",
        attachTo: {
          element: '#bookSwiper > swiper-slide:nth-child(3)',
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.navigateToSlide(0);
              this.tourService.guideTour.cancel();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.navigateToSlide(1);
              setTimeout(() => {
                this.tourService.guideTour.back();
              }, 100)
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.navigateToSlide(0);

              this.headerComponent.isCollapsed = false;
              setTimeout(() => {
                this.headerComponent.addVerticalMenuSteps();
                this.tourService.guideTour.next();
              }, 300);
            }
          }
        ],
        text: "<p>En las siguiente páginas tendrás las imágenes del estudio.</p>" +
          "<p>Podrás pulsarlas para ampliarlas</p>",
      }

    ])

    console.log("Pasos añadidos, iniciando tour");
    setTimeout(() => {
      this.tourService.guideTour.start();
    }, 500)
    TOUR DISABLED */
  }

  onSliderChange(event: Event): void {

    const target = event.target as HTMLInputElement;

    const slideIndex = Number(target.value);

    const swiper = this.bookSwiper?.nativeElement?.swiper;

    if (!swiper) {
      return;
    }

    swiper.slideTo(slideIndex);
  }

  openAdvancedVisor(){

    let studyUID: string | null = null;
    if (this.bookService.currentBook!.studyUIDs[0] != null) {
      studyUID = this.bookService.currentBook!.studyUIDs[0];
    } else {
      studyUID = this.bookService.currentBook!.studyUIDs[0]
    }
    if (studyUID == null) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }
    
    this.openVisorWindow(studyUID, this.token);

  }

  openAdvancedVisorFromHistoric({studyUID, studyToken}: {studyUID: string, studyToken: string}){
    if (studyUID == null) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }

    if(studyToken != null && studyToken != ""){
      this.openVisorWindow(studyUID, studyToken);
    }else{
      this.alertService.alert('No se ha podido obtener el token de acceso. Por favor, póngase en contacto con el centro hospitalario');
    }

  }

  async openVisorWindow(studyUID: string, tkn: string) {

    // Abrir la ventana de forma síncrona para que Safari no la bloquee.
    // Safari solo permite window.open() en el contexto directo del gesto del usuario;
    // cualquier llamada tras un await/promise es bloqueada por el popup blocker.
    const visorWindow = window.open('', 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));

    try {
      const token = await this.bookService.askForToken(tkn);
      console.log('token recibido:', token);
      console.log('studyUID:', studyUID);
      this.configService.getConfig().then(c => {
        const route = c.visorRoute + `?sid=${studyUID}&ustkn=${token}`;
        console.log('route; ', route);
        if (visorWindow) {
          visorWindow.location.href = route;
        }
      })
      
    } catch (error) {
      if (visorWindow) {
        visorWindow.close();
      }
      console.error('Error obteniendo token temporal de acceso:', error);
      this.alertService.alert('Error al obtener el token temporal de acceso. Por favor, póngase en contacto con el centro hospitalario');
    }

    
  }

  onClickOpenBook({studyUID, studyToken}: {studyUID: string, studyToken: string}) {
    if (studyUID != null) {

      if(studyToken != null && studyToken != ""){
        this.openBook(studyToken);
      }else{
        this.alertService.alert('No se ha podido obtener el token de acceso. Por favor, póngase en contacto con el centro hospitalario');
      } 
      
    }else{
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
    }
  }

  openBook(tkn: string) {

    this.bookService.addBookIDToSession(localStorage.getItem('DBAuthTkn'), tkn).then(() => {
        const url = `/books/acceso?tkn=${tkn}`;
        this.window.location.href = url;
      }).catch(error => {
        console.error('Error adding book ID to session:', error);
      });

  }


}
